export function imgLoaded(imgElement) {
    return imgElement.complete && imgElement.naturalHeight !== 0;
}

export function drawImage(ctx, img, canvas) {
    const { width, height } = canvas;
    ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, width, height);
}

export function rotatePoint(ctx, x, y, angle) {
    ctx.translate(x, y);
    ctx.rotate(-angle);
    ctx.translate(-x, -y);
}

// r: real
export function positionToAngle(r, pizzaCount) {
    return anglePerPizza(pizzaCount) * r;
}

export function angleToPosition(angle, pizzaCount) {
    let r = angle / anglePerPizza(pizzaCount);
    while (r > pizzaCount) {
        r -= pizzaCount;
    }
    return r;
}

export function anglePerPizza(pizzaCount) {
    return (2 * Math.PI) / pizzaCount;
}

export function getRewardIndex(reward, opts) {
    const { arrangement, rewards } = opts;
    const pizzas = arrangement.map(id => rewards.find(x => x.id == id));
    const pizzaSkus = pizzas.map(x => x.sku);
    return pizzaSkus.indexOf(reward.sku);
}